import N8nTableHeaderControlsButton from './TableHeaderControlsButton.vue';

export default N8nTableHeaderControlsButton;
